import { render } from "./ConsultarOrcamentoPendente.vue?vue&type=template&id=bd8217c8&scoped=true"
import script from "./ConsultarOrcamentoPendente.vue?vue&type=script&lang=js"
export * from "./ConsultarOrcamentoPendente.vue?vue&type=script&lang=js"

import "./ConsultarOrcamentoPendente.vue?vue&type=style&index=0&id=bd8217c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd8217c8"]])

export default __exports__